export default function ProgramCard({ title, description, link }) {
  return (
    <div
      className="relative group w-full h-full rounded-3xl overflow-hidden
                 bg-white/5 backdrop-blur-xl border border-white/10
                 shadow-[0_0_25px_rgba(0,0,0,0.4)] p-8
                 transition-all duration-500 hover:scale-[1.04]
                 hover:shadow-[0_0_45px_rgba(0,255,255,0.25)]
                 hover:border-neonTurquoise/40"
    >
      {/* Soft Glow Overlay */}
      <div
        className="absolute inset-0 opacity-0 group-hover:opacity-100 
                   transition-opacity duration-500 
                   bg-gradient-to-br from-neonTurquoise/10 via-black/10 to-purple-600/10
                   blur-xl"
      ></div>

      {/* Layered Decorative Frames */}
      <div className="absolute -top-2 -left-2 w-full h-full border border-neonTurquoise/20 rounded-3xl rotate-1 pointer-events-none"></div>
      <div className="absolute -bottom-2 -right-2 w-full h-full border border-purple-500/20 rounded-3xl -rotate-1 pointer-events-none"></div>

      {/* Content */}
      <div className="relative z-10 flex flex-col justify-between h-full text-center">

        <div>
          <h2 className="text-white text-2xl font-extrabold mb-3 drop-shadow-md">
            {title}
          </h2>

          <p className="text-grayText text-sm md:text-base leading-relaxed drop-shadow-sm">
            {description}
          </p>
        </div>

        {/* CTA */}
        <a
          href={link}
          className="mt-6 inline-block text-neonTurquoise font-bold text-sm
                     transition-all duration-300 group-hover:translate-x-1 
                     group-hover:text-neonTurquoise/80"
        >
          Explore →
        </a>
      </div>
    </div>
  );
}
